import { LayoutMode } from '@shesha-io/reactjs';

export const APP_NAME = 'PBF Public Portal';

/**
 * Shesha front-end application key for this portal. Must match the `app_key` seeded into
 * `frwk.front_end_apps` by backend migration M20260805080928 — the backend uses it to scope
 * this portal's main menu, theme and app-level settings separately from the admin portal,
 * which runs on the seeded `default-app`.
 */
export const APPLICATION_KEY = 'pbf-publicportal';

/**
 * Layout mode for the public portal — horizontal top navigation rather than the admin portal's
 * collapsible sidebar. Consumed by `useLayoutSelection` in `src/app/(main)/layout.tsx`.
 */
export const PUBLIC_LAYOUT_MODE: LayoutMode = 'horizontalLayout';

export const ACCESS_TOKEN_NAME = 'xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv';
